import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Sidebar from '../components/Sidebar';
import '../styles/member.css';
import moment from "moment";
import { MDBBadge, MDBBtn, MDBCol, MDBIcon, MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader, MDBModalTitle, MDBPagination, MDBPaginationItem, MDBPaginationLink, MDBTable, MDBTableBody, MDBTableHead } from 'mdb-react-ui-kit';
import { getGymAddonsList, getGymPlansList, getMemeberProfile } from '../../services/memberApiServices';
import { useCart } from '../components/CartContext.js';
import { useNavigate } from 'react-router-dom';
import shape from '../../memberportal/assets/images/badge-shap.png';
import ftinessloader from '../../memberportal/assets/images/loader.gif';
import { Row } from 'reactstrap';
import MembershipTable from '../components/MembershipTable';

const MembershipPlans = () => {
    const { getMemberId, getGymId, handleReload } = useCart();
    const [membership, setMembership] = useState([]);
    const [filteredMembership, setFilteredMembership] = useState([]);
    const { addToCart, isItemInCart } = useCart();
    const [refresh, setRefresh] = useState(false)
    const [filters, setFilters] = useState({
        type: 'all',
        duration: 'all'
    });
    const [basicModal, setBasicModal] = useState(false);
    const cancelOpen = () => setBasicModal(!basicModal);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const [memberInfo, setMemberInfo] = useState({})
    const [currentplan, setCurrentplan] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    useEffect(() => {
        if (getGymId()) {
            fetchPlansAndAddons();
        }

    }, [getGymId, memberInfo]);


    useEffect(() => {
        async function fetchData() {

            const response = await getMemeberProfile(getMemberId());
            if (!response) {
                return;
            }
            if (response == "false") {
                // setApiError(true)
                return;
            }
            const record = await response.json();
            if (!record) {

                navigate("/");
                return;
            }
            console.log(record);
            setMemberInfo(record)

        }
        if (getMemberId()) {
            fetchData();
        }
    }, [getMemberId]);

    useEffect(() => {
        filterMembership();
    }, [refresh]);

    const filterMembership = () => {
        let result = membershipinfo;
        setCurrentPage(1)
        // Filter by type
        if (filters.type !== 'all') {
            result = result.filter(item =>
                filters.type === 'plan' ? item.type === 'plan' : item.type === 'addons'
            );
        }

        // Filter by duration (you might need to adjust this based on your actual duration logic)
        if (filters.duration !== 'all') {
            result = result.filter(item => {
                if (filters.duration === 'day') return item.validityflag === 1;
                if (filters.duration === 'week') return item.validityflag === 7;
                if (filters.duration === 'month') return item.validityflag === 2;
                if (filters.duration === 'year') return item.validityflag === 3;
                return true;
            });
        }
        setRefresh(false)
        setIsLoading(false)
        // setFilteredMembership(result);
        processMembership(result)
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;
        setFilters(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const clearFilters = () => {
        setFilters({
            type: 'all',
            duration: 'all'
        });
        setRefresh(true)
    };
    const [membershipinfo, setMembershipinfo] = useState([])
    const [upgradePlans, setUpgradePlans] = useState([])
    async function fetchPlansAndAddons() {
        setIsLoading(true);
        const userInfo = getGymId();

        if (!localStorage.getItem("loggedMemberInfo") && !localStorage.getItem("memberinfo")) {
            navigate('/memberlogin', { state: { path: '/membershipplans' } });
            return;
        }
        if (!userInfo) return;

        let mergedMembership = [];

        // Fetch Plans
        const plansResponse = await getGymPlansList(userInfo);
        if (plansResponse && plansResponse !== "false") {
            const plansData = await plansResponse.json();
            console.log(plansData, "plansData");

            if (plansData && plansData.length > 0) {
                const visiblePlans = plansData.filter(plan => plan.archived !== true);

                const formattedPlans = visiblePlans.flatMap(plan => {
                    let entries = [];

                    if (plan.memberenable === true) {
                        entries.push({
                            ...plan,
                            type: "plan",
                            duration: `${plan.numberofdays} ${plan.validityflag === 1
                                ? "Days"
                                : plan.validityflag === 2
                                    ? "Months"
                                    : "Years"
                                }`

                        });
                    }

                    if (plan.subplans && plan.subplans.length > 0) {
                        const subplanEntries = plan.subplans
                            .filter(sp => sp.memberenable === true)
                            .map(sp => ({
                                ...sp,
                                type: "plan",
                                parentId: plan._id,
                                displayName: `${plan.name} - ${sp.name}`,
                                duration:
                                    `${sp.numberofdays} ${sp.validityflag === 1
                                        ? "Days"
                                        : sp.validityflag === 2
                                            ? "Months"
                                            : "Years"
                                    }`
                            }));
                        entries = [...entries, ...subplanEntries];
                    }

                    return entries;
                });

                mergedMembership = [...mergedMembership, ...formattedPlans];
            }
        }

        // Fetch Addons
        const addonsResponse = await getGymAddonsList(userInfo);
        if (addonsResponse && addonsResponse !== "false") {
            const addonsData = await addonsResponse.json();
            const enabledAddons = addonsData
                .filter(addon => addon.enable === true && addon?.memberenable === true)
                .map(addon => ({
                    ...addon,
                    type: "addons",
                    duration:
                        addon.rentbasis === '1'
                            ? '1 Day'
                            : addon.rentbasis === '2'
                                ? '1 Week'
                                : addon.rentbasis === '3'
                                    ? '1 Month'
                                    : 'Custom Duration'
                }));
            mergedMembership = [...mergedMembership, ...enabledAddons];
        }

        console.log(mergedMembership, "mergedMembership ✅");
        setMembershipinfo(mergedMembership)
        processMembership(mergedMembership)
    }

    const processMembership = (mergedMembership) => {
        const currentMembership = mergedMembership.find(
            (plan) => plan._id === memberInfo?.planid
        );
        console.log(memberInfo?.planid, 'memberInfo?.planid');

        console.log(currentMembership, "currentMembership ✅");
        setCurrentplan(currentMembership)
        let higherPlans = [];

        if (currentMembership) {
            higherPlans = mergedMembership
                .filter(
                    (plan) =>
                        plan.type === "plan" &&
                        plan.price > currentMembership.price
                )
                .sort((a, b) => a.price - b.price)
                .slice(0, 2);
        } else {

            higherPlans = mergedMembership
                .filter((plan) => plan.type === "plan")
                .sort((a, b) => b.price - a.price)
                .slice(0, 2);
        }

        setUpgradePlans(higherPlans || []);

        const filteredMembership = mergedMembership.filter(
            (plan) =>
                plan._id !== currentMembership?._id &&
                !higherPlans.some((up) => up._id === plan._id)
        );

        setMembership(filteredMembership);
        setIsLoading(false);
    }
    const getDefaultFeatures = (item) => {
        if (item.type === 'plan') {
            const features = [
                `Valid for ${item.numberofdays} day(s)`,
                item.sessioncheck ? `${item.sessionvalue} sessions included` : 'Unlimited sessions',
            ];

            if (item.forcetrainer) {
                features.push("Personalized trainer");
            }

            return features;
        } else {
            return [
                `Gender: ${item.gender === '1' ? 'Male' : item.gender === '2' ? 'Female' : 'Unisex'}`,
                `Rental basis: ${item.rentbasis === '1' ? 'Daily' : item.rentbasis === '2' ? 'Weekly' : 'Monthly'}`,
            ];
        }
    };


    const handleRefresh = () => {
        setRefresh(true)
        handleReload()
    }

    const [showmore, setShowmore] = useState({});
    console.log(showmore, 'showmore');

    const handleDescription = (id) => {
        setShowmore((prev) => ({
            ...prev,
            [id]: !prev[id]
        }));
    };

    const [selectedPlan, setSelectedPlan] = useState({})
    const handlePlandetails = (plan) => {
        setSelectedPlan(plan)
        setBasicModal(true)
    }

    const generateCurrentMembershipInfo = () => {
        if (!memberInfo?.startdate || !memberInfo?.expirydate) return null;

        const start = moment(memberInfo?.startdate);
        const end = moment(memberInfo.expirydate);
        const today = moment();

        if (!start.isValid() || !end.isValid() || end.isBefore(start)) return null;

        const totalDays = end.diff(start, "days");
        const daysPassed = today.diff(start, "days");
        const daysLeft = end.diff(today, "days");

        if (totalDays <= 0 || daysLeft < 0) return null;

        const percentageCompleted = (daysPassed / totalDays) * 100;

        if (percentageCompleted < 70) return null;

        const expiryDate = end.format("DD MMM YYYY");

        return {
            daysLeft,
            expiryDate,
            percentageCompleted: Math.round(percentageCompleted),
            totalDays,
            daysPassed,
        };
    };

    const getMembershipStatus = (memberInfo) => {
        if (!memberInfo) return null;

        if (memberInfo.issuspend) {
            return 2;
        }
        if (memberInfo.membershipstatus) {
            return memberInfo.membershipstatus.toLowerCase();
        }
        const today = new Date();
        const expiry = new Date(memberInfo.expirydate);
        return expiry < today ? 0 : 1;
    };

    if (isLoading) {
        return <div className="dashboard-loading"> <div><img src={ftinessloader} alt="" /> </div> <h4 className='mt-2'> Loading.....</h4></div>;
    }
    return (
        <div className="dashboard-container">
            <Sidebar active={"3"} handleRefresh={handleRefresh} />
            <div className="main-content">
                <Header title={"Plans & Renewals"} />

                <div className="dashboard-content d-flex flex-column h-100">
                    <div className="filters-container">
                        <div className="filter-row">
                            <div className="filter-group">
                                {/* <label class="form-label mb-1">Membership Type</label> */}
                                <select
                                    className="member-filter-select form-select"
                                    name="type"
                                    value={filters.type}
                                    onChange={handleFilterChange}
                                >
                                    <option value="all">All Types</option>
                                    <option value="plan">Plans</option>
                                    <option value="addon">Addons</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                {/* <label class="form-label mb-1">Duration</label> */}
                                <select
                                    className="member-filter-select form-select"
                                    name="duration"
                                    value={filters.duration}
                                    onChange={handleFilterChange}
                                >
                                    <option value="all">All Durations</option>
                                    <option value="day">Daily</option>
                                    <option value="week">Weekly</option>
                                    <option value="month">Monthly</option>
                                    <option value="year">Yearly</option>
                                </select>
                            </div>

                            <div className="filter-buttons">
                                <button className="filter-btn apply-btn" onClick={filterMembership}>
                                    Apply
                                </button>
                                <button
                                    className="filter-btn cancel-btn"
                                    onClick={clearFilters}
                                >
                                    Clear
                                </button>

                            </div>
                        </div>
                    </div>
                    <div className='flex-grow-1 overflow-auto'>

                        <div className='member_newplans-panel mx-3'>
                            {currentplan && generateCurrentMembershipInfo() && (<Row>
                                <MDBCol sm="12" md="12" className="mb-2 mt-1 px-0">
                                    <div className='remember-alert'>
                                        <div>
                                            <p className='mb-0'>Your <strong>{currentplan?.displayName || currentplan?.name}</strong> Membership will expire in <strong>{generateCurrentMembershipInfo().daysLeft}</strong> day(s). Please renew soon to ensure uninterrupted access to your services.</p>
                                            <p className='m-0 d-none d-md-block'>Expires : <span className='fw-bold'>{generateCurrentMembershipInfo().expiryDate}</span> </p>
                                        </div>
                                        <div className='d-flex justify-content-between align-items-center w-0 w-md-100 mt-2 mt-md-0'>
                                            <p className='m-0 d-block d-md-none'>Expires : <span className='fw-bold'>{generateCurrentMembershipInfo().expiryDate}</span> </p>
                                            <MDBBtn
                                                type="submit"
                                                className="nav-btn orng-btn upgradbtn"
                                                color="primary"
                                                onClick={() => navigate('/memberbilling', { state: { cartItems: [currentplan] } })}
                                            >
                                                <span className='session_btn planbtn'> <MDBIcon fas icon="shield-alt" className="me-1" /> Upgrade</span>
                                            </MDBBtn>
                                        </div>
                                    </div>
                                </MDBCol>
                            </Row>)}
                            <Row>
                                {currentplan && (
                                    <MDBCol
                                        className={`ps-0 membershipplan_card ${showmore[currentplan._id] ? "col-md-12" : "col-md-6 col-lg-4 col-sm-12"} `}
                                    >
                                        <div className="new-plan-card experi_plancard mb-2 bg-white p-3 rounded-3 square border">
                                            <div className='flex-grow-1 square border-end pe-3 me-3'>
                                                <div className='mb-2'>
                                                    <p className='m-0 text-muted'>Current Membership
                                                        <MDBBadge className='ms-3' color={getMembershipStatus(memberInfo) == 2 ? "warning" : getMembershipStatus(memberInfo) == 1 ? "success" : "danger"} pill>{getMembershipStatus(memberInfo) == 2 ? "Suspend" : getMembershipStatus(memberInfo) == 1 ? "Active" : "Inactive"}</MDBBadge>
                                                    </p>
                                                    <h5 className="plan-name "> {currentplan?.displayName || currentplan?.name}

                                                        <MDBBadge light className="ms-2" color={currentplan.type === "plan" ? "primary" : "success"}>
                                                            {currentplan.type === "plan" ? "Plan" : "Addon"}
                                                        </MDBBadge>
                                                    </h5>
                                                </div>
                                                <ul className="plan-features">
                                                    {getDefaultFeatures(currentplan).map((feature, idx) => (
                                                        <li key={idx}>
                                                            <i className="fa-solid fa-circle-check me-1 text-secondary"></i> {feature}
                                                        </li>
                                                    ))}
                                                </ul>
                                                {currentplan?.description && currentplan.description.trim() !== "" && (<><div className='d-flex align-items-end'>
                                                    <div style={{ flex: '1' }}>
                                                        <span className='fw-bold'>Description</span>
                                                        <p className={`m-0 ${showmore[currentplan._id] ? "" : "memberplns-ellips"}`}>
                                                            {currentplan?.description}
                                                        </p>
                                                    </div>
                                                </div>
                                                    <span
                                                        className='text-primary d-block cursor-pointer text-end'
                                                        // onClick={() => handleDescription(currentplan._id)}
                                                        onClick={() => handlePlandetails(currentplan)}
                                                    >
                                                        <u>{showmore[currentplan._id] ? "Show Less" : "Show more"}</u>
                                                    </span></>)}
                                            </div>
                                            <div className='d-flex flex-column justify-content-center text-center'>
                                                <div className='d-flex justify-content-center flex-column mb-2'>
                                                    <h4 className='d-flex justify-content-center mb-0'>
                                                        <MDBIcon fas icon="rupee-sign" className='rupee-size' />
                                                        {Number(currentplan?.price ?? currentplan?.props?.[0]?.propvalue ?? 0).toLocaleString('en-IN')}
                                                        <small className='pt-2'>/-</small>
                                                    </h4>
                                                    <label>{currentplan?.duration}</label>
                                                </div>
                                                <MDBBtn className="nav-btn orng-btn upgradbtn" onClick={() => navigate('/memberbilling', { state: { cartItems: [currentplan] } })}>
                                                    <span className='session_btn planbtn'> Renew</span>
                                                </MDBBtn>
                                            </div>
                                        </div>
                                    </MDBCol>
                                )}




                                {upgradePlans.length > 0 &&
                                    upgradePlans.map((item) => (
                                        <MDBCol
                                            className={`ps-0 membershipplan_card ${showmore[item._id] ? "col-md-12" : "col-md-6 col-lg-4 col-sm-12"}`}
                                            key={item._id}
                                        >
                                            <div className="new-plan-card mb-2 bg-white p-3 rounded-3 square border">
                                                <div className='flex-grow-1 square border-end pe-3 me-3'>
                                                    <div className='mb-2'>
                                                        <p className='m-0 text-muted'>Upgrade Membership</p>
                                                        <h5 className="plan-name ">{item?.displayName || item?.name}
                                                            <MDBBadge light className="ms-2" color={item.type === "plan" ? "primary" : "success"}>
                                                                {item.type === "plan" ? "Plan" : "Addon"}
                                                            </MDBBadge>
                                                        </h5>
                                                    </div>
                                                    <ul className="plan-features">
                                                        {getDefaultFeatures(item).map((feature, idx) => (
                                                            <li key={idx}>
                                                                <i className="fa-solid fa-circle-check me-1 text-secondary"></i> {feature}
                                                            </li>
                                                        ))}
                                                    </ul>
                                                    {item?.description && item.description.trim() !== "" && (
                                                        <>
                                                            <div className='d-flex align-items-end'>
                                                                <div style={{ flex: '1' }}>
                                                                    <span className='fw-bold'>Description</span>
                                                                    <p className={`m-0 ${showmore[item._id] ? "" : "memberplns-ellips"}`}>
                                                                        {item?.description}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <span
                                                                className='text-primary d-block cursor-pointer text-end'
                                                                // onClick={() => handleDescription(item._id)}
                                                                onClick={() => handlePlandetails(item)}
                                                            >
                                                                <u>{showmore[item._id] ? "Show Less" : "Show more"}</u>
                                                            </span>
                                                        </>)}

                                                </div>
                                                <div className='d-flex flex-column justify-content-center text-center'>
                                                    <div className='d-flex justify-content-center flex-column mb-2'>
                                                        <h4 className='d-flex justify-content-center mb-0'>
                                                            <MDBIcon fas icon="rupee-sign" className='rupee-size' />
                                                            {Number(item?.price ?? item?.props?.[0]?.propvalue ?? 0).toLocaleString('en-IN')}
                                                            <small className='pt-2'>/-</small>
                                                        </h4>
                                                        <label>{item?.duration}</label>
                                                    </div>
                                                    <MDBBtn className="nav-btn" onClick={() => navigate('/memberbilling', { state: { cartItems: [item] } })}>
                                                        <span className='session_btn planbtn fw-normal'> Upgrade</span>
                                                    </MDBBtn>

                                                </div>
                                            </div>
                                        </MDBCol>
                                    ))}



                            </Row>

                            <MDBCol sm="12" md="12" className="flex-grow-1 mt-1 px-0">
                                <MembershipTable plans={membership} handlePlandetails={handlePlandetails} currentPage={currentPage} setCurrentPage={setCurrentPage} />

                            </MDBCol>


                        </div>
                    </div>
                </div >
            </div >


            <MDBModal tabIndex='-1' open={basicModal} onClose={() => setBasicModal(false)} >
                <MDBModalDialog>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>{selectedPlan?.displayName || selectedPlan?.name}</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={cancelOpen}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <table className="table table-striped table-bordered compressed-table mb-0">
                                <tbody>
                                    <tr>
                                        <td width="150px">Duration</td>
                                        <td> {selectedPlan?.duration}</td>
                                    </tr>
                                    <tr>
                                        <td width="150px">Price</td>
                                        <td>
                                            {Number(selectedPlan?.price ?? selectedPlan?.props?.[0]?.propvalue ?? 0).toLocaleString('en-IN')}
                                            <small className='pt-2'>/-</small></td>
                                    </tr>
                                    <tr>
                                        <td width="150px">Features</td>
                                        <td>  <ul className="plan-features">
                                            {getDefaultFeatures(selectedPlan).map((feature, idx) => (
                                                <li key={idx}>
                                                    <i className="fa-solid fa-circle-check me-1 text-secondary"></i> {feature}
                                                </li>
                                            ))}
                                        </ul></td>
                                    </tr>
                                    <tr>
                                        <td width="150px">Duration</td>
                                        <td> {selectedPlan?.duration}</td>
                                    </tr>
                                    <tr>
                                        <td width="150px">Description</td>
                                        <td> {selectedPlan?.description || "--"}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </MDBModalBody>

                        <MDBModalFooter className='justify-content-between px-2 pb-1'>
                            <div>

                                {isItemInCart(selectedPlan?._id) ? (
                                    <div className='in-cart'>
                                        <i className="fas fa-check-circle"></i>
                                        <span>Added to Cart</span>
                                    </div>
                                ) : (
                                    <MDBBtn onClick={!isItemInCart(selectedPlan?._id) ? () => addToCart(selectedPlan) : null} className="nav-btn me-2">
                                        <span className=''> <i className="fas fa-shopping-cart"></i>  Add to Cart</span>
                                    </MDBBtn>
                                )}
                                <button onClick={() => navigate('/memberbilling', { state: { cartItems: [selectedPlan] } })} className="btn nav-btnoutline">
                                    <span className=''>  <i className="fas fa-credit-card menu-icon"></i>  Buy Now</span>
                                </button>
                            </div>
                            <div>
                                <MDBBtn color='secondary' class="filter-btn cancel-btn square border py-1" onClick={cancelOpen}>
                                    Close
                                </MDBBtn>

                            </div>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>



        </div >
    );
};

export default MembershipPlans;